import React, { Component } from 'react';
// package react-virtualized-select is no longer supported,
// but popular react-select has performance issues
import VirtualizedSelect from 'react-virtualized-select';
import PropTypes from 'prop-types';
import { fetchAKRAUsers, fetchSpacesUsers } from '../../lib/RestClient';
import '../../css/EmployeesDropdown.css';
import 'react-select/dist/react-select.css';
import 'react-virtualized-select/styles.css';

class EmployeesDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      employees: [],
    };
  }

  async componentDidMount() {
    const [akraMemberGroupUsers, spacesGroupUsers] = await Promise.all([
      fetchAKRAUsers().then(res => res.data.value),
      fetchSpacesUsers().then(res => res.data.value),
    ]);

    const employees = [
      ...akraMemberGroupUsers,
      ...spacesGroupUsers.filter(
        item2 => !akraMemberGroupUsers.some(item1 => item1.id === item2.id)
      ),
    ];

    this.setState({ employees });
  }

  getDropdownOptions = employees =>
    employees
      .sort((a, b) => a.surname.localeCompare(b.surname))
      .map(user => ({
        value: `${user.employeeId}`,
        label: `${user.surname}, ${user.givenName}`,
        name: `${user.givenName} ${user.surname}`,
      }));

  render() {
    const { employees } = this.state;
    const { selectedUser, translate } = this.props;
    const options = this.getDropdownOptions(employees);
    return (
      <div className="EmployeesDropdown">
        <style>
          {`
          .EmployeesDropdown .Select-clear-zone:before {
            content: '${translate('reservation.clear')}';
            margin-right: 5px;
          }
        `}
        </style>
        <p className="EmployeesDropdown-label">{translate('reservation.employee')}</p>
        <div>
          <VirtualizedSelect
            placeholder={translate('reservation.select')}
            options={options}
            onChange={this.props.onSelectionChange}
            value={selectedUser && selectedUser.login}
            disabled={this.props.isDisabled}
          />
        </div>
      </div>
    );
  }
}

EmployeesDropdown.propTypes = {
  onSelectionChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  selectedUser: PropTypes.shape({
    name: PropTypes.string,
    login: PropTypes.string,
  }),
  translate: PropTypes.func,
};

EmployeesDropdown.defaultProps = {
  onSelectionChange: () => {},
  selectedUser: null,
  isDisabled: false,
  translate: () => {},
};

export default EmployeesDropdown;
